import useSortModal from "./plpUseSortModal";

export default useSortModal;
